export const inputCls =
  "w-full border-0 border-b border-beige-dark bg-transparent px-0 py-3 text-base text-ink placeholder:text-ink-soft/60 transition-colors duration-300 focus:border-gold focus:outline-none focus:ring-0";

export const Field = ({ id, label, required, hint, error, children }) => (
  <div>
    <label htmlFor={id} className="flex items-baseline justify-between text-[11px] font-semibold uppercase tracking-[0.22em] text-ink-soft">
      <span>
        {label}
        {required && <span className="text-gold-deep"> *</span>}
      </span>
      {hint && <span className="font-normal normal-case tracking-normal text-ink-soft/80">{hint}</span>}
    </label>
    {children}
    {error && (
      <p role="alert" data-testid={`booking-${id}-error`} className="mt-2 text-xs text-[#A23B3B]">
        {error}
      </p>
    )}
  </div>
);
